import {
  GET_PRODUCT_REQ,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_ERROR,
  GET_CATEGORIES_REQ,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_ERROR,
  GET_SHIPPINGCOST_REQ,
  GET_SHIPPINGCOST_SUCCESS,
  GET_SHIPPINGCOST_ERROR,
  UPDATE_SHIPPINGCOST_REQ,
  UPDATE_SHIPPINGCOST_SUCCESS,
  UPDATE_SHIPPINGCOST_ERROR,
  UPDATE_PRODUCT_REQ,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_ERROR,
  POST_PRODUCT_REQ,
  POST_PRODUCT_SUCCESS,
  POST_PRODUCT_ERROR,
  POST_CUSTOMPRODUCT_REQ,
  POST_CUSTOMPRODUCT_SUCCESS,
  POST_CUSTOMPRODUCT_ERROR,
  GET_BASEMIX_CATEGORIES_REQ,
  GET_BASEMIX_CATEGORIES_SUCCESS,
  GET_BASEMIX_CATEGORIES_ERROR,
  GET_BASEMIXES_REQ,
  GET_BASEMIXES_SUCCESS,
  GET_BASEMIXES_ERROR,
  GET_ADDITIVES_REQ,
  GET_ADDITIVES_SUCCESS,
  GET_ADDITIVES_ERROR,
  GET_BASEMIXES_CATEGORIES_REQ,
  GET_BASEMIXES_CATEGORIES_SUCCESS,
  GET_BASEMIXES_CATEGORIES_ERROR,
  POST_BASEMIX_REQ,
  POST_BASEMIX_SUCCESS,
  POST_BASEMIX_ERROR,
  GET_TEMPLATE_REQ,
  GET_TEMPLATE_SUCCESS,
  GET_TEMPLATE_ERROR,
  POST_FILE_REQ,
  POST_FILE_SUCCESS,
  POST_FILE_ERROR,
} from "../constants";

const initialState = {
  isLodading: false,
  products: [],
  metaData: {},
  categories: [],
  shipingcost: {},
  shipingprice: {},
  price: {},
  basemixData: [],
  basemixes: [],
  additives: [],
  basemixesCategories: [],
  basemix: {},
  isLoadingCategorey: false,
  isAddingProduct:false
};
export function CatalogReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CATEGORIES_REQ: {
      return {
        ...state,
        isLoadingCategorey: true,
        categories: [],
      };
    }
    case GET_CATEGORIES_SUCCESS: {
      return {
        ...state,
        isLoadingCategorey: false,
        categories: action.payload,
      };
    }
    case GET_CATEGORIES_ERROR: {
      return {
        ...state,
        isLoadingCategorey: false,
      };
    }
    case GET_PRODUCT_REQ: {
      return {
        ...state,
        isLodading: true,
        products: [],
      };
    }
    case GET_PRODUCT_SUCCESS: {
      return {
        ...state,
        isLodading: false,
        products: action.payload,
        metaData: action.metaData,
      };
    }
    case GET_PRODUCT_ERROR: {
      return {
        ...state,
        isLodading: false,
      };
    }
    case GET_SHIPPINGCOST_REQ: {
      return {
        ...state,

        shipingprice: {},
      };
    }
    case GET_SHIPPINGCOST_SUCCESS: {
      return {
        ...state,

        shipingprice: action.payload,
      };
    }
    case GET_SHIPPINGCOST_ERROR: {
      return {
        ...state,
      };
    }
    case UPDATE_SHIPPINGCOST_REQ: {
      return {
        ...state,
        isLodadingCount: true,
        shipingcost: {},
      };
    }
    case UPDATE_SHIPPINGCOST_SUCCESS: {
      return {
        ...state,
        isLodadingCount: false,
        shipingcost: action.payload,
      };
    }
    case UPDATE_SHIPPINGCOST_ERROR: {
      return {
        ...state,
        isLodadingCount: false,
      };
    }

    case UPDATE_PRODUCT_REQ: {
      return {
        ...state,
        isLodadingCount: true,
        price: {},
      };
    }
    case UPDATE_PRODUCT_SUCCESS: {
      return {
        ...state,
        isLodadingCount: false,
        price: action.payload,
      };
    }
    case UPDATE_PRODUCT_ERROR: {
      return {
        ...state,
        isLodadingCount: false,
      };
    }

    case POST_PRODUCT_REQ: {
      return {
        ...state,
        isAddingProduct: true,
      };
    }
    case POST_PRODUCT_SUCCESS: {
      return {
        ...state,
        isAddingProduct: false,
        // products: action.payload
      };
    }
    case POST_PRODUCT_ERROR: {
      return {
        ...state,
        isAddingProduct: false,
      };
    }

    case POST_CUSTOMPRODUCT_REQ: {
      return {
        ...state,
        // isLodadingCount: true,
      };
    }
    case POST_CUSTOMPRODUCT_SUCCESS: {
      return {
        ...state,
        // isLodadingCount: false,
        // products: action.payload
      };
    }
    case POST_CUSTOMPRODUCT_ERROR: {
      return {
        ...state,
        // isLodadingCount: false,
      };
    }

    case GET_BASEMIX_CATEGORIES_REQ: {
      return {
        ...state,
        basemixData: [],
      };
    }
    case GET_BASEMIX_CATEGORIES_SUCCESS: {
      return {
        ...state,
        basemixData: action.payload,
      };
    }
    case GET_BASEMIX_CATEGORIES_ERROR: {
      return {
        ...state,
        // isLodadingCount: false,
      };
    }
    case GET_BASEMIXES_REQ: {
      return {
        ...state,
        basemixes: [],
      };
    }
    case GET_BASEMIXES_SUCCESS: {
      

      return {
        ...state,
        basemixes: action.payload,
      };
    }
    case GET_BASEMIXES_ERROR: {
      return {
        ...state,
        // isLodadingCount: false,
      };
    }
    case GET_ADDITIVES_REQ: {
      return {
        ...state,
        additives: [],
      };
    }
    case GET_ADDITIVES_SUCCESS: {
      return {
        ...state,
        additives: action.payload,
      };
    }
    case GET_ADDITIVES_ERROR: {
      return {
        ...state,
      };
    }

    case GET_BASEMIXES_CATEGORIES_REQ: {
      return {
        ...state,
        basemixesCategories: [],
      };
    }
    case GET_BASEMIXES_CATEGORIES_SUCCESS: {
      return {
        ...state,
        basemixesCategories: action.payload,
      };
    }
    case GET_BASEMIXES_CATEGORIES_ERROR: {
      return {
        ...state,
      };
    }
    case POST_BASEMIX_REQ: {
      return {
        ...state,
        basemix: {},
      };
    }
    case POST_BASEMIX_SUCCESS: {
      return {
        ...state,
        basemix: action.payload,
      };
    }
    case POST_BASEMIX_ERROR: {
      return {
        ...state,
      };
    }

    case GET_TEMPLATE_REQ: {
      return {
        ...state,
      };
    }
    case GET_TEMPLATE_SUCCESS: {
      return {
        ...state,
      };
    }
    case GET_TEMPLATE_ERROR: {
      return {
        ...state,
      };
    }

    case POST_FILE_REQ: {
      return {
        ...state,
      };
    }
    case POST_FILE_SUCCESS: {
      return {
        ...state,
      };
    }
    case POST_FILE_ERROR: {
      return {
        ...state,
      };
    }

    default:
      return state;
  }
}
